import { handleActions } from 'redux-actions';

import {
  autoAllocationExportRequest,
  autoAllocationExportResponse
} from 'shared/store/modules/autoAllocations/actions';

const defaultState = {};

export default handleActions(
  {
    [autoAllocationExportRequest]: () => defaultState,
    [autoAllocationExportResponse]: {
      next: (_state, { payload }) => payload
    }
  },

  defaultState
);
